import React from 'react';
import './styles.css';

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export default function Slide() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <Slider
            {...settings}>
            <div>
                <img src={require('../../assets/img/1.png')} alt="" />
            </div>

            <div>
                <img src={require('../../assets/img/2.png')} alt="" />
            </div>

            <div>
                <img src={require('../../assets/img/3.png')} alt="" />
            </div>

        </Slider>
    )
}